import styles from '../../index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Popover } from 'antd'
import Utils from '@utils/utils'
import { TYPETITLEMAP, IMAGE_TYPE, CLOTH_COLOR_TYPE, GENERATE_MODE, VIDEO_ORIENTATION, POSE_FANTASY_MODE, RELIGHT_MODE, MODEL_EXPRESSION } from '@utils/CONST'
import RefListModal from '../../../../../BatchProductImages/components/RefListModal'

const ModelLeftCom = (props) => {
    const { item, selectedInputImg, setSelectedInputImg } = props
    const refListModalRef = useRef(null)

    const title = (
        <>
            <p className={styles.title}>{item?.projectName}</p>
            <p>{(item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) ? '自由换色' :
                (item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.SIM_RECOLOR) ? '同款换色' :
                    TYPETITLEMAP[item?.imageType]}</p>
            <p>{item?.createdTime}</p>
        </>
    )
    const mode = <p style={{ marginBottom: '24px' }}>{(item?.mode === GENERATE_MODE.STD || !item?.mode) ? '标准模式' : '高品质模式'}</p>
    const hdMode = <p style={{ marginBottom: '24px' }}>{(item?.hdMode === GENERATE_MODE.STD || !item?.hdMode) ? '标准模式' : '高品质模式'}</p>
    const orientation = <p style={{ marginBottom: '24px' }}>{(item?.orientation === VIDEO_ORIENTATION.REF || !item?.orientation) ? '与参考视频一致' : '与模特图一致'}</p>
    const duration = <p style={{ marginBottom: '24px' }}>{item?.duration == 10 ? '视频时长：10秒' : '视频时长：5秒'}</p>

    const promptTextRef = useRef(null)
    const [promptOverflow, setPromptOverflow] = useState(false)
    const [promptPopoverOpen, setPromptPopoverOpen] = useState(false)
    const promptText = useMemo(() => {
        return item?.prompt
    }, [item])
    useEffect(() => {
        const el = promptTextRef.current
        if (!el) return
        setPromptOverflow(el.scrollHeight > el.clientHeight + 1)
    }, [promptText])
    const prompt = (
        <div className={styles.promptWrap}>
            <div className={styles.promptTextWrap}>
                <p>描述：</p>
                <span ref={promptTextRef} className={styles.promptText}>{promptText}</span>
                {promptOverflow && (
                    <Popover
                        open={promptPopoverOpen}
                        onOpenChange={setPromptPopoverOpen}
                        trigger="hover"
                        placement="bottom"
                        content={<div className={styles.promptPopoverContent}>{promptText}</div>}
                    >
                        <span className={styles.viewAll}>查看全部</span>
                    </Popover>
                )}
            </div>
        </div>
    )
    const skinRefine = <p>肤质高清·开启</p>
    const relight = <p>光影增强·开启</p>
    const relightMode = <p>
        {
            item?.relightMode === RELIGHT_MODE.SKIN ? "标准模式" :
                item?.relightMode === RELIGHT_MODE.PORTRAIT ? "人像模式" : "反光板模式"
        }
    </p>
    const resolutionAlignTitle = item?.resolutionAlign &&
        <p>{item?.resolutionAlign == 'bkg' ? "参考图比例" : item?.resolutionAlign == 'input' ? "上传图比例" : null}</p>
    const recolor = (
        <>
            <p>目标颜色：{item.color}</p>
            <span style={{
                display: 'inline-block',
                backgroundColor: item.color,
                width: '64px',
                height: '64px',
                borderRadius: '8px',
                verticalAlign: 'middle',
            }}>
            </span>
        </>
    )
    const simReColor = (
        <>
            <p>衣服平铺图</p>
            <div className={styles.inputImg}>
                {
                    item?.clothes?.split(',').map((inputItem) => {
                        return <img
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />
                    })
                }
            </div>
        </>
    )
    const modelEmoji = <p>模特表情：{item?.emoji === MODEL_EXPRESSION.SRC ? '按原图' : '按参考图'}</p>
    const inputImg = (
        <>
            <p>
                {item?.imageType == IMAGE_TYPE.CLOTHES ? '衣服平铺图' : item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? '首帧图' : '输入图'}
                <span style={{ marginLeft: '46px' }}>{(item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && item?.imageTail) && '尾帧图'}</span>
            </p>
            <div className={styles.inputImg}>
                {
                    item?.inputImage?.split(',').map((inputItem) => {
                        return <img
                            className={(selectedInputImg == inputItem && item?.inputImage?.split(',').length > 1) ? styles.inputImgSelected : ''}
                            key={inputItem}
                            onClick={() => setSelectedInputImg(inputItem)}
                            src={Utils.getImgThumbnail(inputItem)} alt="" />
                    })
                }
                {
                    item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && item?.imageTail && <img
                        key={item?.imageTail}
                        onClick={() => setSelectedInputImg(item?.imageTail)}
                        src={Utils.getImgThumbnail(item?.imageTail)} alt="" />
                }
            </div>
        </>
    )
    const poseImg = (
        <>
            <p>试衣参考图</p>
            <img src={Utils.getImgThumbnail(item?.pose?.url)} alt="" />
        </>
    )
    const poseTryonImg = (
        item?.mode == POSE_FANTASY_MODE.REFERENCEMODE ? <>
            <p>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
        </> : prompt
    )
    const glassesTryonImg = (
        <>
            <p>{item?.glassesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.glassesRef?.url)} alt="" />
        </>
    )
    const simTryonImg = (
        <>
            <p>{item?.poseRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.poseRef?.url)} alt="" />
        </>
    )
    const modelImg = item?.person?.url &&  (
        <>
            {item?.keepPose ? null : <p>模特图：{
                item?.person?.custom ? "自定义模特" :
                    item?.person?.title?.split("-").pop()}</p>}
            {!item?.keepPose && <img src={Utils.getImgThumbnail(item?.person?.url)} alt="" />}
        </>
    )
    const bkgImg = item?.background?.url && (
        <>
            {
                item?.keepBkg ? null : <p>背景图：{
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()}</p>
            }
            {!item?.keepBkg && <img src={Utils.getImgThumbnail(item?.background?.url)} alt="" />}
        </>
    )
    const shoesImg = (
        <>
            <p>{item?.shoesRef?.custom ? "自定义参考图" : '预设参考图'}</p>
            <img src={Utils.getImgThumbnail(item?.shoesRef?.url)} alt="" />
        </>
    )
    // 搭配上身搭配圖
    const matchImages = (
        item?.matchImages && <>
            <p>商品图</p>
            <div className={styles.refListImg}>
                <div className={styles.refListImgFirst}>
                    <img src={Utils.getImgThumbnail(item?.matchImages?.[0]?.url)}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setSelectedInputImg(item?.matchImages?.[0]?.url)} alt="" />
                    {
                        item?.matchImages?.length > 1 &&
                        <img src={Utils.getImgThumbnail(item?.matchImages?.[1]?.url)}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setSelectedInputImg(item?.matchImages?.[1]?.url)} alt="" />
                    }
                </div>
                {item?.matchImages?.length > 2 &&
                    <div
                        className={styles.refListImgItem}
                        style={{ cursor: 'pointer' }}
                        onClick={() => refListModalRef?.current?.open(item?.matchImages)}>
                        <img src={Utils.getImgThumbnail(item?.matchImages?.[2]?.url)} alt="" />
                        <span>+{item?.matchImages?.length || 1}</span>
                    </div>}
            </div>
        </>
    )
    // 搭配上身模特图
    const modelTryonImg = item?.modelImage?.url && (
        <>
            <p>模特图</p>
            <img style={{ cursor: 'pointer' }}
                onClick={() => setSelectedInputImg(item?.modelImage?.url)}
                src={Utils.getImgThumbnail(item?.modelImage?.url)} alt="" />
        </>
    )

    const showConent = (
        item?.imageType == IMAGE_TYPE.CLOTHES ? (
            <>
                {title}
                {mode}
                {inputImg}
                {poseImg}
                {modelImg}
                {bkgImg}
            </>
        ) : item?.imageType == IMAGE_TYPE.MODEL || item?.imageType == IMAGE_TYPE.BACKGROUND ?
            (
                <>
                    {title}
                    {item?.emoji && item?.imageType != IMAGE_TYPE.BACKGROUND ? modelEmoji : null}
                    {item?.skinRefine ? skinRefine : null}
                    {item?.relight > 0 ? relight : null}
                    {(item.relightMode && item.relight > 0) ? relightMode : null}
                    {resolutionAlignTitle}
                    {inputImg}
                    {modelImg}
                    {bkgImg}
                </>
            ) : item?.imageType == IMAGE_TYPE.SHOES ?
                (
                    <>
                        {title}
                        {mode}
                        {inputImg}
                        {shoesImg}
                    </>
                ) : item?.imageType == IMAGE_TYPE.MODEL_VIDEO ?
                    (
                        <>
                            {title}
                            {inputImg}
                            {mode}
                            {orientation}
                            {prompt}
                        </>
                    ) : item?.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ?
                        (
                            <>
                                {title}
                                {inputImg}
                                {mode}
                                {duration}
                                {prompt}
                            </>
                        ) : item?.imageType == IMAGE_TYPE.COMMODITYRECOLOR ?
                            (
                                <>
                                    {title}
                                    {hdMode}
                                    {recolor}
                                </>
                            ) : item?.imageType == IMAGE_TYPE.CLOTH_RECOLOR ?
                                (
                                    <>
                                        {title}
                                        {inputImg}
                                        {(item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ? recolor : simReColor)}
                                    </>
                                ) : item?.imageType == IMAGE_TYPE.COMMODITY ?
                                    (
                                        <>
                                            {title}
                                            {mode}
                                            {inputImg}
                                            {bkgImg}
                                        </>
                                    ) : item?.imageType == IMAGE_TYPE.POSE_TRYON ?
                                        (
                                            <>
                                                {title}
                                                {hdMode}
                                                {inputImg}
                                                {poseTryonImg}
                                            </>
                                        ) : item?.imageType == IMAGE_TYPE.GLASSES_TRYON ?
                                            (
                                                <>
                                                    {title}
                                                    {mode}
                                                    {inputImg}
                                                    {glassesTryonImg}
                                                </>
                                            ) : item?.imageType == IMAGE_TYPE.SIM_TRYON ?
                                                (
                                                    <>
                                                        {title}
                                                        {inputImg}
                                                        {simTryonImg}
                                                    </>
                                                ) : item?.imageType == IMAGE_TYPE.FUSION_WEAR ?
                                                    (
                                                        <>
                                                            {title}
                                                            {mode}
                                                            {matchImages}
                                                            {modelTryonImg}
                                                            {prompt}
                                                        </>
                                                    ) : item?.imageType == IMAGE_TYPE.GRASS_PLANT ?
                                                        (
                                                            <>
                                                                {title}
                                                                {mode}
                                                                {modelImg}
                                                                {bkgImg}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {title}
                                                                {inputImg}
                                                            </>
                                                        )
    )


    return (
        <>
            <div className={`${styles.ModelLeftCom} _beauty_scrollbar`}>
                {showConent}
            </div>
            <RefListModal ref={refListModalRef} onSelect={setSelectedInputImg} />
        </>

    )
}

export default ModelLeftCom